export const DATASET_CREATE_SECTION = 'DatasetCreation';
export const DATA_PROCESSING_SECTION = 'DataProcessing';

export function extractOptionsBySection(advancedSettingsOptions = []) {
  if (!advancedSettingsOptions) return {};
  return advancedSettingsOptions.reduce(
    (previousValue, currentConfiguration) => {
      if (DATA_PROCESSING_SECTION === currentConfiguration.section.replace(/\s/g, '')) {
        return {
          ...previousValue,
          [DATA_PROCESSING_SECTION]: [
            ...previousValue[DATA_PROCESSING_SECTION],
            currentConfiguration,
          ],
        };
      }

      return {
        ...previousValue,
        [DATASET_CREATE_SECTION]: [...previousValue[DATASET_CREATE_SECTION], currentConfiguration],
      };
    },
    {
      [DATASET_CREATE_SECTION]: [],
      [DATA_PROCESSING_SECTION]: [],
    },
  );
}
